import { WalletAccount } from '@exodus/models'

// eslint-disable-next-line @exodus/export-default/named
export default {
  error: null,
  loaded: false,
  // flag while replacing all data with data in fusion
  data: {
    [WalletAccount.DEFAULT_NAME]: WalletAccount.DEFAULT,
  },
  multipleWalletAccountsEnabled: false,
  // prefix to avoid confusion with selector
  configuredActiveWalletAccount: null,
}
